// extracted by mini-css-extract-plugin
export var dividerLine = "_4y-0";
export var errorBackground = "_4y-1";